import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchObligations = periodName => fetch(
  Config.endpoints.FETCH_OBLIGATIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Obligations failed' }))
  .then(parseAsJson);

export const fetchUploadedObligations = jobId => fetch(
  Config.endpoints.FETCH_JOB_RESULTS
    .replace(/:jobId/, jobId)
)
  .then(handleErrors({ errorMessage: 'Fetching uploaded Obligations failed' }))
  .then(parseAsJson)
  .then(response => response?.resultData);

export const fetchUserAssignedCompanyCodes = periodName => fetch(
  Config.endpoints.FETCH_USER_ASSIGNED_COMPANY_CODES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching user assigned company codes failed' }))
  .then(parseAsJson);

export const fetchCharts = async periodName => await fetch(
  Config.endpoints.FETCH_CHART_NAMES_ALL
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching All Chart Names failed' }))
  .then(parseAsJson);

export const fetchUsTaxTypes = async () => await fetch(Config.endpoints.FETCH_US_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching Tax Types failed' }))
  .then(parseAsJson);

export const fetchLocalTaxTypes = async () => await fetch(Config.endpoints.FETCH_LOCAL_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching Tax Types failed' }))
  .then(parseAsJson);

export const fetchCountryTaxTypes = async periodName => await fetch(
  Config.endpoints.FETCH_COUNTRY_TAX_TYPES_FOR_OBLIGATIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Country Tax Types failed' }))
  .then(parseAsJson);

export const fetchTaxCurrencyDefaultCodes = async () => await fetch(
  Config.endpoints.FETCH_TAX_CURRENCY_DEFAULT_CODES_FOR_OBLIGATIONS
)
  .then(handleErrors({ errorMessage: 'Fetching Tax Currency Codes failed' }))
  .then(parseAsJson);

export const fetchCurrencyCodes = async () => await fetch(Config.endpoints.FETCH_CURRENCY_CODES_ENABLED)
  .then(handleErrors({ errorMessage: 'Fetching Currency Codes failed' }))
  .then(parseAsJson);

export const fetchConnections = async () => await fetch(Config.endpoints.FETCH_CURRENCY_CODES_ENABLED)
  .then(handleErrors({ errorMessage: 'Fetching Connections failed' }))
  .then(parseAsJson);

export const fetchCompanyCodes = async periodName => await fetch(
  Config.endpoints.FETCH_COMPANY_CODES_ADMIN
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Company Codes failed' }))
  .then(parseAsJson);

export const updateObligation = (obligation, { periodName }) => fetch(
  Config.endpoints.UPDATE_OBLIGATION
    .replace(/:periodName/, periodName),
  {
    method: 'PUT',
    body: JSON.stringify(obligation),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Obligation failed', parseResponseErrorMessage: true, parseResponseErrorWithDetails: true }));

export const createObligation = (obligation, { periodName }) => fetch(
  Config.endpoints.CREATE_OBLIGATION
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(obligation),
  }
)
  .then(handleErrors({ errorMessage: 'Creating Obligation failed' }));

export const validateObligations = (obligations, { periodName }) => fetch(
  Config.endpoints.VALIDATE_OBLIGATIONS
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(obligations),
  }
)
  .then(handleErrors({ errorMessage: 'Validating Obligations failed' }))
  .then(parseAsJson);

export const importObligations = (obligations, { periodName }) => fetch(
  Config.endpoints.IMPORT_OBLIGATIONS
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(obligations),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Obligations failed' }));

export const removeObligation = obligation => fetch(
  Config.endpoints.REMOVE_OBLIGATION
    .replace(/:periodName/, obligation.periodName)
    .replace(/:companyCode/, obligation.companyCode)
    .replace(/:countryCode/, obligation.countryCode)
    .replace(/:countryTaxType/, obligation.countryTaxType),
  {
    method: 'DELETE',
  }
).then(handleErrors({ errorMessage: 'Deleting Obligation failed' }));

export const fetchFilingGroups = async periodName => await fetch(
  Config.endpoints.FETCH_FILING_GROUPS_FOR_OBLIGATIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Filing Groups failed' }))
  .then(parseAsJson);
